export const REQUEST_TIMEOUT = 10000;
const BASE_API = '/new/poll';
const CSI_API = `${BASE_API}/api`;
const CSI_API_SI = `${CSI_API}_si`;

export const SESSION_API = `${BASE_API}/session` as const;

// Флаг и геттер для управления версиями API
let useSiApi = false;

export const getApiBase = () => (useSiApi ? CSI_API_SI : CSI_API);

export const switchToSiApi = () => {
  useSiApi = true;
};
